import {
  ApplicationRef,
  createComponent,
  EnvironmentInjector,
  Injectable,
  Injector,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastRef } from './toast-ref';
import {
  ToastComponent,
  ToastData,
} from './toast.component';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private container!: HTMLElement;

  constructor(
    private appRef: ApplicationRef,
    private injector: Injector,
    private envInjector: EnvironmentInjector,
    private translate: TranslateService
  ) {
    this.initContainer();
  }

  private initContainer() {
    this.container = document.createElement('div');
    this.container.className =
      'toast-container position-fixed bottom-0 end-0 p-5';
    this.container.style.zIndex = '1200';
    document.body.appendChild(this.container);
  }

  show(
    translationKey: string,
    actionBtn: string = '',
    duration = 3000,
    type: 'success' | 'danger' | 'info' | 'warning' = 'info'
  ) {
    this.translate
      .get([translationKey, actionBtn])
      .subscribe((translated) => {
        const data: ToastData = {
          message: translated[translationKey],
          action: translated[actionBtn],
          type,
          duration,
        };

        this.showToast(data);
      });
  }

  private showToast(data: ToastData): ToastRef {
    const componentRef = createComponent(ToastComponent, {
      environmentInjector: this.envInjector,
      elementInjector: this.injector,
    });

    const instance = componentRef.instance;
    instance.data = data;

    this.appRef.attachView(componentRef.hostView);

    const domElem = componentRef.location.nativeElement;
    this.container.appendChild(domElem);

    const ref = new ToastRef(componentRef, this.appRef);
    instance.ref = ref;

    if (data.duration && data.duration > 0) {
      setTimeout(() => ref.close(), data.duration);
    }

    return ref;
  }
}
